
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import Button from '../../components/base/Button';

export default function Services() {
  const services = [
    {
      title: 'Immunoglobulin Therapy (IVIG & SCIG)',
      icon: 'ri-shield-cross-line',
      description: 'Advanced immunoglobulin replacement therapy for primary immune deficiencies, autoimmune disorders, and neurological conditions. Administered with precision monitoring and pharmaceutical-grade safety protocols in a calm, private environment.',
      conditions: [
        'Primary Immune Deficiencies',
        'Guillain-Barré Syndrome (GBS)',
        'Chronic Inflammatory Demyelinating Polyneuropathy (CIDP)',
        'Immune Thrombocytopenia (ITP)',
        'Myasthenia Gravis',
        'Multifocal Motor Neuropathy (MMN)',
        'Kawasaki Disease',
        'Autoimmune Encephalitis',
        'Small Fiber Neuropathy',
        'Stiff Person Syndrome'
      ],
      medications: 'Privigen, Gammagard, Gamunex-C',
      image: 'https://public.readdy.ai/ai/img_res/08ace409734ac2c8232e0bf23c01b13d.jpg'
    },
    {
      title: 'Biologic & Specialty Infusion Therapies',
      icon: 'ri-medicine-bottle-line',
      description: 'Expert administration of monoclonal antibody therapies for autoimmune and inflammatory conditions. Continuous clinical monitoring with immediate physician access ensures optimal safety and therapeutic outcomes.',
      conditions: [
        'Rheumatoid Arthritis',
        'Psoriatic Arthritis',
        'Ulcerative Colitis & Crohn\'s Disease',
        'Lupus',
        'Plaque Psoriasis',
        'Ankylosing Spondylitis'
      ],
      medications: 'Remicade, Actemra, Stelara, Entyvio, Simponi Aria, Cimzia',
      image: 'https://readdy.ai/api/search-image?query=Professional%20medical%20biologic%20infusion%20room%20with%20comfortable%20patient%20chair%20and%20IV%20equipment%2C%20soft%20warm%20lighting%20in%20tranquil%20clinical%20setting%2C%20caring%20nurse%20preparing%20medication%20in%20pristine%20medical%20workspace%2C%20peaceful%20outpatient%20infusion%20center%20with%20natural%20light%2C%20modern%20healthcare%20facility%20interior%20photography&width=600&height=500&seq=biologic-calm-002&orientation=landscape'
    },
    {
      title: 'Enzyme Replacement Therapy (ERT)',
      icon: 'ri-flask-line',
      description: 'Specialized enzyme replacement therapy for rare genetic metabolic disorders. Our clinical team provides expert administration with meticulous monitoring protocols and compassionate care for patients requiring long-term enzyme supplementation.',
      conditions: [
        'Gaucher Disease',
        'Fabry Disease',
        'Pompe Disease',
        'MPS I (Hurler Syndrome)',
        'MPS II (Hunter Syndrome)'
      ],
      medications: 'Cerezyme, Fabrazyme, Lumizyme, Elaprase',
      image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20medical%20enzyme%20therapy%20infusion%20room%20with%20comfortable%20reclining%20chair%2C%20soft%20natural%20lighting%20in%20peaceful%20clinical%20environment%2C%20professional%20nurse%20with%20specialized%20medication%20preparation%2C%20tranquil%20outpatient%20rare%20disease%20treatment%20facility%2C%20warm%20calming%20medical%20atmosphere%2C%20contemporary%20healthcare%20photography&width=600&height=500&seq=ert-calm-003&orientation=landscape'
    },
    {
      title: 'Coagulation & Clotting Support',
      icon: 'ri-heart-pulse-line',
      description: 'Comprehensive coagulation factor replacement therapy for hemophilia and bleeding disorders. Administered by specialized clinical staff trained in hematologic protocols with continuous safety monitoring and immediate intervention capability.',
      conditions: [
        'Hemophilia A',
        'Hemophilia B',
        'Von Willebrand Disease',
        'Factor Deficiencies',
        'Other Bleeding Disorders'
      ],
      medications: 'Amicar, ADVATE, ADYNOVATE, Alphanate SD, Feiba, NovoSeven',
      image: 'https://readdy.ai/api/search-image?query=Professional%20medical%20coagulation%20therapy%20room%20with%20comfortable%20patient%20chair%20and%20specialized%20equipment%2C%20gentle%20lighting%20in%20calm%20clinical%20space%2C%20expert%20nurse%20monitoring%20hemophilia%20treatment%2C%20serene%20outpatient%20hematology%20facility%20with%20warm%20atmosphere%2C%20modern%20medical%20interior%20photography&width=600&height=500&seq=coag-calm-004&orientation=landscape'
    },
    {
      title: 'Neurology Infusions',
      icon: 'ri-brain-line',
      description: 'Specialized infusion therapy for neurological conditions including multiple sclerosis, chronic inflammatory neuropathies, and neuromuscular disorders. Extended monitoring protocols with continuous vital sign assessment and immediate intervention capability in a comfortable, private setting.',
      conditions: [
        'Multiple Sclerosis (MS)',
        'Chronic Inflammatory Demyelinating Polyneuropathy (CIDP)',
        'Chronic Migraines',
        'Myasthenia Gravis',
        'Neuromyelitis Optica'
      ],
      medications: 'Ocrevus, Tysabri, Soliris, Vyvgart, Vyepti',
      image: 'https://readdy.ai/api/search-image?query=Peaceful%20medical%20infusion%20suite%20with%20comfortable%20reclining%20chair%20for%20neurology%20treatment%2C%20soft%20natural%20light%20in%20private%20clinical%20room%2C%20attentive%20nursing%20care%20with%20advanced%20monitoring%20equipment%2C%20tranquil%20outpatient%20neurology%20facility%2C%20professional%20healthcare%20photography&width=600&height=500&seq=neuro-calm-005&orientation=landscape'
    },
    {
      title: 'Iron Infusion Therapy',
      icon: 'ri-heart-add-line',
      description: 'Comprehensive intravenous iron replacement using Injectafer, Venofer, Feraheme, and ferric gluconate for severe iron deficiency anemia. Safe, effective treatment for patients who cannot tolerate oral iron or require rapid restoration of iron stores.',
      conditions: [
        'Severe Iron Deficiency Anemia',
        'Chronic Kidney Disease',
        'Inflammatory Bowel Disease',
        'Post-Surgical Anemia',
        'Malabsorption Disorders'
      ],
      medications: 'Injectafer, Venofer, Feraheme, Ferric Gluconate',
      image: 'https://readdy.ai/api/search-image?query=Calm%20medical%20infusion%20room%20with%20reclining%20chair%20and%20iron%20therapy%20IV%20setup%2C%20gentle%20natural%20lighting%20in%20comfortable%20clinical%20space%2C%20professional%20nurse%20monitoring%20patient%20care%2C%20serene%20outpatient%20treatment%20environment%20with%20warm%20atmosphere%2C%20modern%20medical%20facility%20photography&width=600&height=500&seq=iron-calm-006&orientation=landscape'
    },
    {
      title: 'Medical-Grade IV Hydration',
      icon: 'ri-drop-line',
      description: 'Physician-directed intravenous hydration therapy for acute dehydration, severe nausea, migraines, and post-operative recovery. Administered with clinical precision in a calm, comfortable environment.',
      conditions: [
        'Severe Dehydration',
        'Hyperemesis Gravidarum',
        'Migraine Relief',
        'Post-Surgical Recovery',
        'Gastroenteritis'
      ],
      medications: 'Customized IV Fluid Formulations',
      image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20medical%20hydration%20therapy%20room%20with%20comfortable%20patient%20chair%20and%20IV%20setup%2C%20soft%20natural%20lighting%20in%20tranquil%20clinical%20space%2C%20professional%20nursing%20care%20in%20peaceful%20outpatient%20setting%2C%20warm%20calming%20atmosphere%2C%20contemporary%20healthcare%20facility%20photography&width=600&height=500&seq=hydration-calm-007&orientation=landscape'
    },
    {
      title: 'NAD+ IV Therapy',
      icon: 'ri-flashlight-line',
      description: 'Advanced NAD+ infusion therapy for cellular energy support, recovery enhancement, and metabolic optimization. Administered under medical supervision with continuous monitoring for patient comfort and safety.',
      conditions: [
        'Energy Support',
        'Recovery Enhancement',
        'Metabolic Health',
        'Cellular Optimization'
      ],
      medications: 'Pharmaceutical-Grade NAD+',
      image: 'https://readdy.ai/api/search-image?query=Upscale%20medical%20infusion%20room%20with%20comfortable%20reclining%20chair%20for%20NAD%20therapy%2C%20soft%20warm%20lighting%20in%20serene%20clinical%20environment%2C%20professional%20nurse%20with%20IV%20equipment%2C%20peaceful%20outpatient%20wellness%20facility%2C%20modern%20medical%20interior%20photography&width=600&height=500&seq=nad-calm-008&orientation=landscape'
    },
    {
      title: 'Vitamin & Mineral IV Therapy',
      icon: 'ri-test-tube-line',
      description: 'Customized intravenous vitamin and mineral formulations including B12, vitamin C, and supportive nutrient blends. Physician-approved protocols delivered with clinical precision for optimal absorption and therapeutic benefit.',
      conditions: [
        'Vitamin B12 Deficiency',
        'Immune Support',
        'Fatigue Management',
        'Nutritional Optimization'
      ],
      medications: 'B12, Vitamin C, Custom Nutrient Blends',
      image: 'https://readdy.ai/api/search-image?query=Professional%20medical%20vitamin%20IV%20therapy%20room%20with%20comfortable%20patient%20chair%2C%20gentle%20natural%20lighting%20in%20calm%20clinical%20setting%2C%20nurse%20preparing%20nutrient%20infusion%20in%20pristine%20workspace%2C%20peaceful%20outpatient%20medical%20facility%2C%20modern%20healthcare%20photography&width=600&height=500&seq=vitamin-calm-009&orientation=landscape'
    },
    {
      title: 'Therapeutic Injections',
      icon: 'ri-syringe-line',
      description: 'Expert administration of therapeutic injections including B12, Toradol for pain management, and anti-nausea medications. Quick, professional service with attentive clinical care.',
      conditions: [
        'B12 Deficiency',
        'Acute Pain Management',
        'Nausea Relief',
        'Migraine Treatment'
      ],
      medications: 'B12, Toradol, Zofran, Custom Formulations',
      image: 'https://readdy.ai/api/search-image?query=Clean%20medical%20injection%20room%20with%20comfortable%20patient%20chair%2C%20soft%20lighting%20in%20professional%20clinical%20space%2C%20nurse%20preparing%20therapeutic%20injection%2C%20calm%20outpatient%20medical%20facility%20with%20warm%20atmosphere%2C%20modern%20healthcare%20interior%20photography&width=600&height=500&seq=injection-calm-010&orientation=landscape'
    }
  ];

  const conditions = [
    {
      category: 'Autoimmune Disorders',
      icon: 'ri-shield-cross-line',
      description: 'Comprehensive infusion therapy for lupus, rheumatoid arthritis, inflammatory bowel disease, and other autoimmune conditions requiring biologic or immunoglobulin treatment.'
    },
    {
      category: 'Gastrointestinal Conditions',
      icon: 'ri-capsule-line',
      description: 'Specialized biologic infusions for Crohn\'s disease, ulcerative colitis, and inflammatory bowel disorders with seamless gastroenterology coordination.'
    },
    {
      category: 'Neurological Conditions',
      icon: 'ri-brain-line',
      description: 'Expert care for CIDP, myasthenia gravis, multiple sclerosis, Guillain-Barré syndrome, and peripheral neuropathies requiring IVIG or specialty infusions.'
    },
    {
      category: 'Hematology Needs',
      icon: 'ri-heart-pulse-line',
      description: 'Advanced iron replacement therapy for severe anemia, blood disorders, hemophilia, and conditions requiring rapid restoration of iron stores or specialized hematologic treatment.'
    },
    {
      category: 'Immunodeficiency',
      icon: 'ri-shield-check-line',
      description: 'Regular IVIG therapy for primary and secondary immunodeficiency disorders with meticulous monitoring and pharmaceutical-grade safety protocols.'
    },
    {
      category: 'Rare Genetic Disorders',
      icon: 'ri-dna-line',
      description: 'Specialized enzyme replacement therapy for Gaucher disease, Fabry disease, Pompe disease, and mucopolysaccharidoses with expert clinical management.'
    },
    {
      category: 'Chronic Migraine',
      icon: 'ri-pulse-line',
      description: 'Medical-grade IV hydration and therapeutic injections for acute migraine relief and chronic migraine management under physician direction.'
    },
    {
      category: 'Chronic Fatigue',
      icon: 'ri-battery-charge-line',
      description: 'Supportive IV therapies including NAD+, vitamin infusions, and nutrient optimization for patients experiencing persistent fatigue and energy depletion.'
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow">
        <section className="bg-gradient-to-br from-[#f8f9fa] via-white to-[#f0f4f8] py-24">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-6xl font-bold text-[#0f1e32] mb-8">Comprehensive Specialty Infusion Services</h1>
              <p className="text-2xl text-gray-600 leading-relaxed mb-6">
                Expert-guided infusion therapy delivered with precision, comfort, and care in a calm, private outpatient setting.
              </p>
              <p className="text-lg text-gray-500 leading-relaxed">
                All services are physician-directed and administered by critical-care trained clinical specialists with continuous medical oversight and meticulous safety standards.
              </p>
            </div>
          </div>
        </section>

        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="space-y-24">
              {services.map((service, index) => (
                <div key={index} className={`grid grid-cols-1 lg:grid-cols-2 gap-16 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                  <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                    <div className="flex items-center space-x-5 mb-6">
                      <div className="w-16 h-16 bg-gradient-to-br from-[#0f1e32] to-[#1e3a5f] rounded-xl flex items-center justify-center flex-shrink-0 shadow-md">
                        <i className={`${service.icon} text-3xl text-[#d4af37]`}></i>
                      </div>
                      <h2 className="text-4xl font-bold text-[#0f1e32]">{service.title}</h2>
                    </div>
                    <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                      {service.description}
                    </p>
                    <div className="bg-gradient-to-br from-[#f8f9fa] to-white rounded-2xl p-7 border border-gray-200 shadow-sm mb-6">
                      <h3 className="font-bold text-[#0f1e32] mb-5 text-lg">Conditions We Treat:</h3>
                      <ul className="grid grid-cols-1 gap-3">
                        {service.conditions.map((condition, idx) => (
                          <li key={idx} className="flex items-start space-x-3">
                            <i className="ri-check-line text-[#d4af37] text-xl flex-shrink-0 mt-0.5"></i>
                            <span className="text-gray-700 leading-relaxed">{condition}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="bg-gradient-to-br from-[#0f1e32] to-[#1e3a5f] rounded-xl p-5 shadow-md">
                      <h3 className="font-bold text-[#d4af37] mb-2 text-base">Common Medications:</h3>
                      <p className="text-white leading-relaxed">{service.medications}</p>
                    </div>
                  </div>
                  <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                    <img
                      src={service.image}
                      alt={service.title}
                      className="rounded-2xl shadow-xl w-full h-[500px] object-cover object-top"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-24 bg-gradient-to-br from-[#f8f9fa] via-[#f0f4f8] to-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="text-center mb-20">
              <h2 className="text-5xl font-bold text-[#0f1e32] mb-6">Conditions We Support</h2>
              <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
                Zeus Specialty Infusion Clinic provides expert care for a comprehensive range of medical conditions requiring advanced infusion therapy with continuous clinical monitoring and physician oversight.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {conditions.map((condition, index) => (
                <div key={index} className="bg-white rounded-2xl p-7 shadow-md hover:shadow-xl transition-all border border-gray-200">
                  <div className="w-14 h-14 bg-gradient-to-br from-[#0f1e32] to-[#1e3a5f] rounded-xl flex items-center justify-center mb-5 shadow-sm">
                    <i className={`${condition.icon} text-3xl text-[#d4af37]`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#0f1e32] mb-3">{condition.category}</h3>
                  <p className="text-gray-600 leading-relaxed text-sm">{condition.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="bg-gradient-to-br from-[#0f1e32] to-[#1e3a5f] rounded-3xl p-16 text-white text-center shadow-2xl">
              <div className="w-20 h-20 bg-[#d4af37] rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg">
                <i className="ri-hospital-line text-4xl text-[#0f1e32]"></i>
              </div>
              <h2 className="text-5xl font-bold mb-8">Physician Referral Support</h2>
              <p className="text-2xl text-gray-100 mb-6 max-w-4xl mx-auto leading-relaxed font-light">
                We make it easy for physicians to refer patients with a streamlined process that includes comprehensive insurance verification, rapid prior authorization coordination, and same-week scheduling.
              </p>
              <p className="text-lg text-gray-200 mb-12 max-w-3xl mx-auto leading-relaxed">
                Our dedicated clinical coordination team handles all administrative details, allowing you to focus on patient care while we ensure seamless access to medically necessary infusion therapy.
              </p>
              <div className="flex flex-wrap justify-center gap-5">
                <Link to="/physicians">
                  <Button variant="secondary" size="lg" className="!px-10 !py-4 !text-lg">
                    <i className="ri-file-text-line mr-2"></i>
                    Physician Referral Portal
                  </Button>
                </Link>
                <Link to="/contact">
                  <Button variant="outline" size="lg" className="!text-white !border-white hover:!bg-white hover:!text-[#0f1e32] !px-10 !py-4 !text-lg">
                    <i className="ri-calendar-line mr-2"></i>
                    Schedule Appointment
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="py-24 bg-gradient-to-br from-[#f8f9fa] to-white">
          <div className="max-w-5xl mx-auto px-6 lg:px-12 text-center">
            <h2 className="text-4xl font-bold text-[#0f1e32] mb-6">Experience Advanced Infusion Care</h2>
            <p className="text-xl text-gray-600 mb-10 leading-relaxed max-w-3xl mx-auto">
              Whether you're a patient seeking expert infusion therapy or a physician looking for a trusted specialty infusion partner, Zeus Specialty Infusion Clinic delivers uncompromising clinical excellence with compassionate care.
            </p>
            <div className="flex flex-wrap justify-center gap-5">
              <Link to="/contact">
                <Button variant="primary" size="lg" className="!px-10 !py-4 !text-lg">
                  <i className="ri-phone-line mr-2"></i>
                  Contact Our Team
                </Button>
              </Link>
              <Link to="/physicians">
                <Button variant="secondary" size="lg" className="!px-10 !py-4 !text-lg">
                  <i className="ri-hospital-line mr-2"></i>
                  Physician Resources
                </Button>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
